/**
 * Generates a pseudo-random UUID-style string.
 * @returns {string} The generated UUID-style string.
 */
export function generateRandomID(): string {
    const hexDigits = "0123456789abcdef";
    let id = "";

    for (let i = 0; i < 36; i++) {
        if (i === 8 || i === 13 || i === 18 || i === 23) {
            id += "-";
        } else if (i === 14) {
            id += "4"; // Version 4 UUID
        } else if (i === 19) {
            id += hexDigits[(Math.random() * 4) | 8]; // Variant 8 (random 8, 9, A, or B)
        } else {
            id += hexDigits[Math.floor(Math.random() * 16)];
        }
    }

    return id;
}
